import tiktokIcon from "@/assets/icon-tiktok.webp";
import shopeeIcon from "@/assets/icon-shopee.jpg";

export function PlatformIcon({ type, size = 16 }: { type: string; size?: number }) {
  const src = type === "tiktok" ? tiktokIcon : shopeeIcon;
  const alt = type === "tiktok" ? "TikTok" : "Shopee";
  return (
    <img
      src={src}
      alt={alt}
      className="rounded object-cover shrink-0"
      style={{ width: size, height: size }}
    />
  );
}
